// extracted by css-extract-rspack-plugin
export default {"dialogHeaderContainer":"SignedCommitDialog-module__dialogHeaderContainer___4tcVBw","signatureLinkContent":"SignedCommitDialog-module__signatureLinkContent__WgVrnJT"};